import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/login.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { ArchivePageComponent } from './features/documents/archive-page.component';
import { AdminPageComponent } from './features/admin/admin-page.component';
import { ShellComponent } from './layout/shell.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'archive', component: ArchivePageComponent },
      { path: 'admin', component: AdminPageComponent },
      { path: '', redirectTo: 'archive', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: '' }
];
